import React, { useEffect, useState } from "react";
import ContactoEmergencia from "./ContactoEmergencia";
import Chips from "./Chips";
import dayjs from "dayjs";
import { apiRequest } from "../../../../hooks/apiRequest";
import PacienteableInfo from "../../Components/PacienteableInfo";

const HistorialPaciente = ({paciente, onChange, saving, errors}) => {
    const [historial, setHistorial] = useState([]);

    const getHistorial = async (paciente_id) => {
        if (paciente_id) {
            const response = await apiRequest({}, `salud/visitas?paciente=${paciente_id}&limit=15`, 'get');

            if (response.data) {
                return response.data;
            }
        }

        return [];
    }

    useEffect(() => {
        getHistorial(paciente?.id).then((items) => setHistorial(items));
    }, [paciente?.id]);


    return <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
        <h1 className="text-center mb-0">Historial del Paciente</h1>
        <small className="text-center mx-auto mb-2 my-0 text-info">Hacer click en los iconos para editar la información</small>

        <div className="row py-2 px-4">
            <div style={{width: '70px'}} className="mx-2">
                <span className="page-title-foto m-0">
                    <img src={paciente.foto ?? '/images/icon/avatar.png'} />
                </span>
            </div>

            <div className="col p-0">
                <h3 className="mt-2 mb-auto" style={{fontSize: '18px'}}>{ paciente.nombre_completo }</h3>

                <span>Tipo de contacto: <strong>{paciente.tipo}</strong></span>
            </div>
        </div>

        <div className="row px-4">
            <PacienteableInfo
                paciente={paciente}
                disabled={saving}
                onChange={onChange}
                errors={errors}
            ></PacienteableInfo>
        </div>

        <div className="row my-1 px-4">
            <div className="col">
                <h4>Código</h4>
                <span>{paciente.codigo}</span>
            </div>

            <div className="col">
                <h4>Contacto Emergencia</h4>
                <ContactoEmergencia
                    value={paciente.contacto_emergencia ?? {}}
                    disabled={saving}
                    onChange={(contacto_emergencia) => onChange({
                            ...paciente,
                            contacto_emergencia
                        })
                    }
                ></ContactoEmergencia>

                {(errors['paciente.contacto_emergencia']) && (
                    <small className='help-blockParams form-Text'>
                        Este campo es requerido.<br/>
                    </small>
                )}

                {(errors['paciente.contacto_emergencia.nombre']) && (
                    <small className='help-blockParams form-Text'>
                        El nombre es requerido.<br/>
                    </small>
                )}

                {(errors['paciente.contacto_emergencia.telefono']) && (
                    <small className='help-blockParams form-Text'>
                        El telefono es requerido.
                    </small>
                )}
            </div>
        </div>

        <div className="row py-2 px-4">
            <div className="col">
                <h4>Alergias</h4>
                <Chips
                    values={paciente.alergias}
                    disabled={saving}
                    onChange={(alergias) => onChange({
                        ...paciente,
                        alergias
                    })}
                />
            </div>
        </div>

        <div className="row py-2 px-4">
            <div className="col">
                <h4>Condiciones Medicas</h4>
                <Chips
                    values={paciente.condiciones_medicas}
                    disabled={saving}
                    onChange={(condiciones_medicas) => onChange({
                        ...paciente,
                        condiciones_medicas
                    })}
                />
            </div>
        </div>
        
        
        <div className="row mt-4">
            <div className="col text-center"> 
                <h4>Historial de Visitas</h4>
                {historial.length > 0 ? (<table className='table table-data2'>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Tipo de Vísita</th>
                            <th>Motivo</th>
                        </tr>
                    </thead>

                    <tbody>
                        {historial.map(visita => <tr key={visita.id}>
                            <td>{dayjs(visita.fecha).format('DD/MM/YYYY hh:mm a')}</td>
                            <td>{visita.tipo}</td>
                            <td>{visita.motivo.descripcion}</td>
                        </tr>)}
                    </tbody>
                </table>) : 'No hay ninguna visita anterior.'}
            </div>
        </div>
    </div>;
};

export default HistorialPaciente;
